<template>
  <div id="func-56">
    <funcionalidade-header
        v-if="showHeader"
        titulo="Avaliação"
    />
    <div class="pesquisa-content">
      <Pesquisa
          :canal="pesquisa.canal"
          :id-template-pesquisa="pesquisa.idTemplatePesquisa"
          :pesquisa-envio-id="pesquisa.pesquisaEnvioId"
          :show-header="showHeader"
          :template-pesquisa="pesquisaTemplate"
          :status-code="statusCode"
      />
    </div>
  </div>
</template>
<script>
import Pesquisa from '@/components/Pesquisa/Pesquisa.vue'
import { mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'

export default {
  name: 'Func56',
  components: { FuncionalidadeHeader, Pesquisa },
  computed: {
    ...mapState('SetupApp', ['embedJson']),
    pesquisa () {
      try {
        return this.embedJson.pesquisa
      } catch (ignored) {
        return {}
      }
    },
    showHeader () {
      return this.embedJson.showHeader || false
    },
    pesquisaTemplate () {
      try {
        return this.embedJson.pesquisaTemplate
      } catch (ignored) {
        return {}
      }
    },
    statusCode () {
      try {
        return this.embedJson.statusCode
      } catch (ignored) {
        return {}
      }
    }
  }
}
</script>
<style scoped lang="less">
#func-56 {
  padding: 0 20px;
  .pesquisa-content {
    margin-top: 20px;
  }
}
</style>
